/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strength_Level_StarterInputs */

const en_strength_level_starter = /** @type {(inputs: Strength_Level_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter`)
};

const pl_strength_level_starter = /** @type {(inputs: Strength_Level_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Starter" |
*
* @param {Strength_Level_StarterInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const strength_level_starter = /** @type {((inputs?: Strength_Level_StarterInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strength_Level_StarterInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_strength_level_starter(inputs)
	return en_strength_level_starter(inputs)
});